import React, { useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  Platform,
  ScrollView,
  Dimensions,
} from "react-native";

import AppTheme from "../AppTheme";
import SwipeablePanel from "../common/SwipeablePanel/index";
import TimePickerSwipeHeader from "../common/timepicker/TimePickerSwipeHeader";
import appStyles from "../../appStyles";
import ManaButton from "../common/ManaButton";
import { hasItems, isWeb } from "../../../helpers/utils";
import ChunkedIntegrationsSection from "../integrations/details/ChunkedIntegrationsSection";

const { height: HEIGHT } = Dimensions.get("window");

export default function TrackIntegrationsMenu({
  controller,
  timeslot,
  isAutoTrackMode = false,
  close = () => {},
  clearTimeslot = () => {},
  goToEditPage = () => {},
  onLongPress = () => {},
}) {
  const otherActivities = timeslot.integration.otherActivities || [];
  const activeIntegrations = timeslot?.integration?.activeIntegrations;

  const [panelProps] = useState({
    fullWidth: true,
    openLarge: false,
    showCloseButton: true,
    noBar: false,
    paddingHorizontal: 0,
    panelColor: "#FFF",
    closeOnTouchOutside: true,
    bgStyle: {
      bottom: isAutoTrackMode ? 50 : 0,
      backgroundColor: "transparent",
    },
    closeRootStyle: { right: 10, top: 8 },
    onClose: () => close(),
    onPressCloseButton: () => close(),
  });

  return (
    <SwipeablePanel {...panelProps} isActive={!!timeslot}>
      <View style={styles.section}>
        <TimePickerSwipeHeader timeslot={timeslot} />
      </View>

      <ScrollView
        style={[
          {
            overflow: "visible",
          },
          isWeb && { maxHeight: HEIGHT * 0.5 },
        ]}
      >
        {hasItems(activeIntegrations) ? (
          <ChunkedIntegrationsSection
            controller={controller}
            integrations={activeIntegrations}
            onLongPress={onLongPress}
          />
        ) : null}

        {hasItems(otherActivities) ? (
          <ChunkedIntegrationsSection
            controller={controller}
            integrations={otherActivities}
            title="Your other activities"
          />
        ) : null}
      </ScrollView>

      {isAutoTrackMode ? null : (
        <View style={[appStyles.horizontalButtons, { paddingTop: 16 }]}>
          <ManaButton
            onPress={() => goToEditPage(timeslot, { multiple: true })}
            style={[styles.button, { marginRight: 7 }]}
            styleText={styles.buttonText}
            text="Track Multiple Elements"
          />

          <ManaButton
            isMainButton
            onPress={() => goToEditPage(timeslot, { replace: true })}
            style={styles.button}
            styleText={styles.buttonText}
            text="Replace Element"
          />
        </View>
      )}

      {isAutoTrackMode ? null : (
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 16,
            paddingBottom: 42,
          }}
        >
          <Text style={styles.clear} onPress={() => clearTimeslot(timeslot)}>
            Clear Timeslot
          </Text>
        </View>
      )}
    </SwipeablePanel>
  );
}

const styles = StyleSheet.create({
  section: {
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 16,
  },
  button: {
    width: "auto",
    paddingHorizontal: 10,
    borderRadius: 6,
    minWidth: 170,
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  clear: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#DD5F43",
  },
});
